module.exports = __webpack_public_path__ + "static/media/pythonLogo.31041d50.png";